<!-- Incluye un input que permite buscar Pales por Codigo de barras -->
<template>
  <div class="div-componenteBusqueda">
    <f7-row>
      <f7-col :width="mostrarBtnBusquedaCodigo ? 80 : 100">
        <div v-show="modoLectura === modosLectura.CODIGO">
          <p v-show="mostrarTitulo">
            {{ $t('production.palletMaking.code.search.title') }}
          </p>
          <!-- Lectura por Codigo de Barras -->
          <form
            class="from-busquedas"
            @submit.prevent="IntroducidoCodigoDeBarras()"
          >
            <f7-row class="row-campoDeEntrada seleccionable">
              <f7-col width="20">
                <div class="div-modoInput">
                  <div
                    class="div-btnModoInput"
                    @click="modoLectura = modosLectura.NUMEROSERIE"
                  >
                    <img
                      src="@/static/icons/ic_code.svg"
                      alt="iconBarcode"
                      width="50"
                      height="50"
                    >
                  </div>
                </div>
                <div class="div-btnInformacionCambioCirculo">
                  <img
                    src="@/static/icons/ic_exchange_arrows.svg"
                    alt="iconExchange"
                    width="18"
                    height="18"
                  >
                </div>
              </f7-col>
              <f7-col width="80">
                <div class="div-campoDeEntrada">
                  <input
                    id="input-PCBuscadorPaleConfeccionado"
                    type="text"
                    class="input-busquedaCodigos"
                    :label="$t('production.palletMaking.code.palletBarcode')"
                    :placeholder="$t('production.palletMaking.code.palletBarcode')"
                    :value="valorCampoLectura"
                    accept="number"
                    @input="valorCampoLectura = $event.target.value"
                  >
                </div>
              </f7-col>
            </f7-row>
          </form>
        </div>

        <div v-show="modoLectura === modosLectura.NUMEROSERIE">
          <p v-show="mostrarTitulo">
            {{ $t('production.palletMaking.serialNumber.search.title') }}
          </p>
          <!-- Lectura por Numero de serie Palé -->
          <form
            class="from-busquedas"
            @submit.prevent="IntroducidoNumeroSerie()"
          >
            <f7-row class="row-campoDeEntrada">
              <f7-col width="20">
                <div class="div-modoInput seleccionable">
                  <div
                    class="div-btnModoInput"
                    @click="modoLectura = modosLectura.CODIGO"
                  >
                    <img
                      src="@/static/icons/ic_logistic_unit.svg"
                      alt="iconUnidad"
                      width="35"
                      height="35"
                    >
                  </div>
                </div>
                <div class="div-btnInformacionCambioCirculo">
                  <img
                    src="@/static/icons/ic_exchange_arrows.svg"
                    alt="iconExchange"
                    width="18"
                    height="18"
                  >
                </div>
              </f7-col>
              <f7-col width="80">
                <div class="div-campoDeEntrada">
                  <input
                    id="input-PCBuscadorPaleConfeccionado"
                    type="text"
                    class="input-busquedaCodigos"
                    :label="$t('production.palletMaking.serialNumber.palletSerialNumber')"
                    :placeholder="$t('production.palletMaking.serialNumber.palletSerialNumber')"
                    :value="valorCampoLectura"
                    @input="valorCampoLectura = $event.target.value"
                  >
                </div>
              </f7-col>
            </f7-row>
          </form>
        </div>
      </f7-col>

      <f7-col
        v-if="mostrarBtnBusquedaCodigo"
        width="20"
        class="div-botonCodigoQR seleccionable"
      >
        <img
          src="@/static/icons/qr-code.svg"
          alt="iconQrCode"
          @click="LeerCodigoBarrasPale"
        >
      </f7-col>
    </f7-row>

    <UCCodeScanner
      ref="CodeEscanner"
      :fab-button-show="false"
      @code-reading="Buscar"
      @codigo-barras="Buscar"
    />
  </div>
</template>

<script>
import { nextTick } from 'vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import eventBus from '@/js/event-bus';
import ConexionTA from '@/js/services/traceability/APITraceability';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCBuscadorPaleConfeccionado',
  components: {
    UCCodeScanner,
  },
  props: {
    mostrarTitulo: { type: Boolean, default: false },
    cargarExistenciasPale: { type: Boolean, default: false },
    cargarDatosPedidoVentaDelPale: { type: Boolean, default: false },
    buscarCodigoDeBarras: { type: String, default: null }, // Cuando es distinto de indefinido y null, cuando cambia lanza una busqueda de código establecido en esta propiedad.
    modoOffline: { type: Boolean, default: false }, // Cuando se establece en true retorna el elemento buscando sin validar.
    mostrarBtnBusquedaCodigo: { type: Boolean, default: false }, // Muestra el btn que permite hacer busquedas por QR o código de barras.
  },

  emits: ['paleEstablecido'],

  data() {
    return {
      /**
       * @public
       */
      modosLectura: { CODIGO: 'Codigo', NUMEROSERIE: 'ns' },
      modoLectura: '',
      valorCampoLectura: '', // Valor que contiene el input de elemento de producción
      elementoPale: null, // Almacena el objeto elemento Palé una vez validado
      cargarExistenciasPaleBuscado: false, // relacionado con la propiedad CargarExistenciasPale
      cargarDatosPedidoVentaDelPaleBuscado: false, // relacionado con la propiedad cargarDatosPedidoVentaDelPale,
      cargarArticulosElaborados: false,
    };
  },
  watch: {
    buscarCodigoDeBarras(val) {
      // Log(this, this.buscarCodigoDeBarras.name);
      if (val != null && val !== undefined) {
        this.LecturaDeCodigoDeBarrasRealizada(val);
      } else {
        this.RestablecerControl();
      }
    },
  },
  created() {
    this.InicializarComponente();
  },
  beforeUnmount() {
    this.modoLectura = this.modosLectura.NUMEROSERIE;
  },
  methods: {
    /**
     * Sets the focus on the input element.
     * @public
     * @returns {void}
     */
    establecerEnfoqueCampoBusqueda() {
      nextTick(() => {
        const campoBusqueda = this.$el.querySelector('.input-busquedaCodigos');
        if (campoBusqueda) {
          campoBusqueda.focus();
        }
      });
    },
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.modoLectura = this.modosLectura.NUMEROSERIE;
      // Obtenemos el valor de la propiedad del componente cargarExistenciasPale
      if (this.cargarExistenciasPale !== undefined && this.cargarExistenciasPale) {
        this.cargarExistenciasPaleBuscado = this.cargarExistenciasPale;
      }
      // Obtenemos el valor de la propiedad del componente cargarDatosPedidoVentaDelPale
      if (this.cargarDatosPedidoVentaDelPale !== undefined && this.cargarDatosPedidoVentaDelPale) {
        this.cargarDatosPedidoVentaDelPaleBuscado = this.cargarDatosPedidoVentaDelPale;
      }
    },

    validarCodigo() {
      Log(this, this.validarCodigo.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.palletMaking.code.validation.preloader.title'));
      ConexionTA.callObtenePalePorCodigoDeBarras(this.valorCampoLectura, this.cargarExistenciasPaleBuscado, this.cargarDatosPedidoVentaDelPaleBuscado, this.cargarArticulosElaborados).then((result) => {
        if (result.Valor) {
          self.elementoPale = JSON.parse(result.Mensaje);
          if (self.elementoPale.Existencias.length === 0) {
            f7.dialog.close();

            const alertText = this.$t('production.palletMaking.code.validation.alert.notFound.text', {
              serialNumber: self.elementoPale.NumeroSerie,
            });
            HiNotification.Alert(alertText, this.$t('common.error'));

            return;
          }
          HiDialog.Preloader(false);
          self.notificarPaleEstablecido();
          self.RestablecerControl();
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('production.palletMaking.code.validation.alert.error.text'), this.$t('common.error'));
          LogError('error');
        });
    },
    /** @public */
    Buscar(codigoBarras) {
      Log(this, this.Buscar.name);
      this.LecturaDeCodigoDeBarrasRealizada(codigoBarras);
    },
    /** @public */
    ValidarNumeroSerie() {
      Log(this, this.ValidarNumeroSerie.name);
      const self = this;

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      HiDialog.Preloader(true, preloaderText);

      ConexionTA.callObtenePalePorNumeroDeSerie(this.valorCampoLectura, this.cargarExistenciasPaleBuscado, this.cargarDatosPedidoVentaDelPaleBuscado).then((result) => {
        if (result.Valor) {
          self.elementoPale = JSON.parse(result.Mensaje);
          if (self.elementoPale.Existencias.length === 0) {
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('production.palletMaking.serialNumber.validation.alert.notFound.text'), this.$t('common.error'));
            return;
          }
          HiDialog.Preloader(false);
          self.notificarPaleEstablecido();
          self.RestablecerControl();
        } else {
          HiDialog.Preloader(false);
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          HiDialog.Preloader(false);
          HiNotification.Alert(this.$t('production.palletMaking.serialNumber.validation.alert.error.text'), this.$t('common.error'));
          LogError('error');
        });
    },

    /** * notificarPaleEstablecido */
    notificarPaleEstablecido() {
      Log(this, this.notificarPaleEstablecido.name);
      eventBus.emit('PCBuscadorPaleConfeccionado_paleEstablecido', this.elementoPale);
      this.$emit('paleEstablecido', this.elementoPale);
    },
    /** * RestablecerControl */
    RestablecerControl() {
      Log(this, this.RestablecerControl.name);
      this.elementoPale = null;
      this.valorCampoLectura = '';
      // Quitamos el Foco del elemento input
      const elemento = document.getElementById('input-PCBuscadorPaleConfeccionado');
      elemento.blur();
    },
    /** * LecturaDeCodigoDeBarrasRealizada */
    LecturaDeCodigoDeBarrasRealizada(codigoLeido) {
      Log(this, this.LecturaDeCodigoDeBarrasRealizada.name);
      this.modoLectura = this.modosLectura.CODIGO;
      this.valorCampoLectura = codigoLeido;
      this.IntroducidoCodigoDeBarras();
    },
    /** * IntroducidoCodigoDeBarras */
    IntroducidoCodigoDeBarras() {
      Log(this, this.IntroducidoCodigoDeBarras.name);
      if (this.modoOffline !== undefined && this.modoOffline === true) {
        const tempPaleSinValidar = { CodigoBarrasPale: this.valorCampoLectura };
        eventBus.emit('PCBuscadorPaleConfeccionado_paleEstablecido', tempPaleSinValidar);
        this.$emit('paleEstablecido', tempPaleSinValidar);
        this.RestablecerControl();
      } else {
        this.validarCodigo();
      }
    },

    /** * IntroducidoNumeroSerie */
    IntroducidoNumeroSerie() {
      Log(this, this.IntroducidoNumeroSerie.name);
      if (this.modoOffline !== undefined && this.modoOffline === true) {
        const tempPaleSinValidar = { NumeroSerie: this.valorCampoLectura };
        eventBus.emit('PCBuscadorPaleConfeccionado_paleEstablecido', tempPaleSinValidar);
        this.$emit('paleEstablecido', tempPaleSinValidar);
        this.RestablecerControl();
      } else {
        this.ValidarNumeroSerie();
      }
    },
    LeerCodigoBarrasPale() {
      Log(this, this.LeerCodigoBarrasPale.name);
      this.$refs.CodeEscanner.Open();
    },
  },
};
</script>

<style scoped>
.div-campoDeEntrada {
  box-sizing: border-box;
  background: #fff;
  margin-right: 18px;
  margin-left: 18px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  min-height: 60px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.input-busquedaCodigos {
  width: 100%;
  height: 100%;
  padding-left: 19px;
  padding-right: 19px;
  color: #24253da8;
  font-size: 17px;
  margin-top: 22px;
  margin-bottom: 16px;
}

.div-modoInput {
  margin-top: 16px;
  margin-bottom: 0;
}

.div-btnModoInput {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin-right: 15px;
  margin-left: 15px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  height: 100%;
  width: 100%;
  min-height: 60px;
  box-shadow: 0 6px 10px #6666662b;
}

.div-btnInformacionCambioCirculo {
  height: 27px;
  width: 27px;
  border-radius: 50%;
  border: 1px solid var(--his-silver);
  background: var(--his-tierra-white);
  box-sizing: border-box;
  position: relative;
  left: 55%;
  top: -13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-botonCodigoQR {
  border: 1px solid var(--his-silver);
  background: var(--his-tierra-white);
  border-radius: 8px;
  margin-right: 16px;
  min-height: 65px;
  text-align: center;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 8px;
  padding-right: 4px;
  max-height: 56px;
  margin-top: 15px;
}

/** Animación codigo de barras **/
.escanerCodigoBarras-popup .page {
  background: var(--his-tierra-white);
}

.center {
  margin: 0 auto;
  text-align: center;
}

.spacer {
  margin-top: 6rem;
}

.anim-box {
  position: relative;
  width: 220px;
  height: 100px;
  padding: 25px 30px;
}

.anim-box::before,
.anim-box::after,
.anim-box > :first-child::before,
.anim-box > :first-child::after {
  position: absolute;
  width: 10%;
  height: 15%;
  border-color: #fff;
  border-style: solid;
  content: " ";
}

.anim-box::before {
  top: 0;
  left: 0;
  border-width: 2px 0 0 2px;
}

.anim-box::after {
  top: 0;
  right: 0;
  border-width: 2px 2px 0 0;
}

.anim-box > :first-child::before {
  bottom: 0;
  right: 0;
  border-width: 0 2px 2px 0;
}

.anim-box > :first-child::after {
  bottom: 0;
  left: 0;
  border-width: 0 0 2px 2px;
}

.anim-item {
  display: inline-block;
  background-color: #282829;
  height: 100px;
}

.anim-item-sm {
  width: 2px;
  margin-right: 3px;
}

.anim-item-md {
  width: 3px;
  margin-right: 2px;
}

.anim-item-lg {
  width: 5px;
  margin-right: 5px;
}

.scanner {
  width: 100%;
  height: 3px;
  background-color: red;
  opacity: 0.7;
  position: relative;
  box-shadow: 0 0 8px 10px rgb(170 11 23 / 49%);
  top: 50%;
  animation-name: scan;
  animation-duration: 4s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  /* animation-play-state: paused; */
}

@keyframes scan {
  0% {
    box-shadow: 0 0 8px 10px rgb(170 11 23 / 49%);
    top: 50%;
  }

  25% {
    box-shadow: 0 6px 8px 10px rgb(170 11 23 / 49%);
    top: 5px;
  }

  75% {
    box-shadow: 0 -6px 8px 10px rgb(170 11 23 / 49%);
    top: 98%;
  }
}
</style>
